import { FeedbackState } from '../types/FeedbackState'
import { GetterTree } from 'vuex'

export const getters: GetterTree<FeedbackState, any> = {
  message: state => state.message,
  context: state => state.context,
  show: state => state.show,
  duration: state => state.duration,
}
